import { useSelector } from 'react-redux'
import {
  shouldShowEnrollmentPaymentNotification,
  shouldShowPaymentReceivedNotification
} from 'utils/hmoUtils'

/**
 * Derives which pinned payment notification (if any) should show for the current
 * member. Shared by ActivitySection (home) and MyActivity (full list) so the S9
 * request-payment / payment-received gating logic lives in exactly one place.
 */
export const usePaymentNotifications = () => {
  const userDetails = useSelector(state => state.profile?.userDetails)

  const showEnrollmentPaymentNotification =
    shouldShowEnrollmentPaymentNotification(userDetails)
  const showPaymentReceivedNotification =
    shouldShowPaymentReceivedNotification(userDetails)
  const hasPinnedPaymentNotification =
    showEnrollmentPaymentNotification || showPaymentReceivedNotification

  return {
    showEnrollmentPaymentNotification,
    showPaymentReceivedNotification,
    hasPinnedPaymentNotification
  }
}

export default usePaymentNotifications
